import React from 'react';
import {
    ImageMedia,
    VideoMedia,
    AudioMedia,
    AudioError,
    DocumentMedia,
    StickerMedia,
    LocationMedia,
    ContactMedia,
    PixMedia,
    PollMedia,
    MediaFallback,
    MessageMediaProps,
} from './media/index.js';
import { isDisplayableMediaUrl } from '../../../../utils/failedImageCache';

/** Tipos que caem em MediaFallback quando a URL não é exibível (document tem card próprio). */
const URL_MEDIA_TYPES = new Set(['image', 'video', 'sticker']);

export const MessageMedia: React.FC<MessageMediaProps> = ({
    type,
    media,
    content,
    isMe,
    senderName,
    senderAvatar,
    timestamp,
    status,
    chatPlatform = 'whatsapp',
}) => {
    // Tipos complexos que usam Content (JSON)
    if (type === 'location') {
        return (
            <LocationMedia
                content={content}
                timestamp={timestamp}
                status={status}
                isMe={isMe}
            />
        );
    }
    if (type === 'contact') return <ContactMedia content={content} />;
    if (type === 'pix') {
        return (
            <PixMedia
                content={content}
                timestamp={timestamp}
                status={status}
                isMe={isMe}
            />
        );
    }
    if (type === 'poll') return <PollMedia content={content} />;

    // Documento: card com nome mesmo sem media_url (stub oversized / download pendente).
    if (type === 'document') {
        return <DocumentMedia media={media || { url: '' }} content={content} isMe={isMe} />;
    }

    // Tipos de mídia que exigem URL
    // Áudio sem URL = erro
    if (type === 'audio' && !media?.url) {
        return <AudioError />;
    }

    // Sem URL exibível (vazio / CDN efêmera): placeholder com status — não “indisponível”.
    // Áudio: AudioMedia trata erro de playback e mantém avatar do remetente.
    if (URL_MEDIA_TYPES.has(type) && !isDisplayableMediaUrl(media?.url)) {
        return <MediaFallback type={type} status={status} />;
    }

    // Renderiza mídia com URL
    if (media?.url) {
        switch (type) {
            case 'image':
                return <ImageMedia media={media} status={status} />;
            case 'video':
                return <VideoMedia media={media} status={status} />;
            case 'audio':
                return (
                    <AudioMedia
                        media={media}
                        isMe={isMe}
                        senderName={senderName}
                        senderAvatar={senderAvatar}
                        chatPlatform={chatPlatform}
                    />
                );
            case 'sticker':
                return <StickerMedia media={media} status={status} />;
        }
    }

    return null;
};
